import React, { useEffect, useState } from 'react';

/**
 * YatasSapVeri: Yataş Grubu SAP entegrasyonunda talep edeceğimiz alanların
 * eksiksiz listesi — web siparişleri, sipariş satırları, iadeler ve pazar yeri
 * siparişleri için dört tablo, artı teslim şartları.
 * Route: /r/yatas-sap-veri (sidebar YOK, tam ekran belge)
 *
 * İçerik statik — API çağrısı yok. Belge Yataş'ın SAP ve e-ticaret ekiplerine
 * gönderilecek bir teslimat; alanlar A–H bloklarına ayrıldı ki yazışmalarda
 * harfleriyle referans verilebilsin.
 *
 * 🔑 "PDF olarak kaydet" düğmesi iframe'in KENDİ belgesinde `window.print()`
 * çağırır — tarayıcı yalnızca belgeyi basar, dashboard'u değil. Dış sayfadan
 * Ctrl+P ise `position:fixed` iframe'i tek sayfaya kırpar, o yüzden düğme
 * belgenin İÇİNDE duruyor; dışarı taşıma.
 *
 * HTML modülü ~40KB. Ana bundle'da işi yok, dinamik import ile yükleniyor.
 */
export default function YatasSapVeri() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./yatasSapVeriHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1A1D1C">Belge yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini belgenin kendi zeminiyle aynı (--ground açık tema) — açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#FBFAF8' }} />;

  return (
    <iframe
      title="Yataş Grubu · SAP Veri Talebi"
      srcDoc={html}
      style={fill}
    />
  );
}
